import { ResumeLanguage } from "lib/redux/types";
import React from "react";
import { ResumePDFDescription, TemplateEighteenPDFSectionWithSubsections } from "./common";
import { View } from "@react-pdf/renderer";
import { spacing, styles } from "../ResumePDF/styles";
import { ResumePDFText } from "../ResumePDF/common";

const Languages = ({
  heading,
  languages,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  languages: ResumeLanguage[];
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateEighteenPDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      <View
        wrap={false}
        style={{
          ...styles.flexRow,
          flexWrap: "wrap",
        }}
      >
        {languages.map(({ language, level, descriptions }, idx) => (
          <View
            key={idx}
            style={{
              ...styles.flexCol,
              width: "40%",
              marginBottom: spacing["1"],
              marginRight: spacing["1"],
            }}
          >
            <View style={{ ...styles.flexRow, gap: 4 }}>
              <ResumePDFText bold={true}>
                {language}
                {level && ":"}
              </ResumePDFText>
              {level && <ResumePDFText>{level}</ResumePDFText>}
            </View>
            <View style={{ ...styles.flexRow, marginTop: spacing["0.5"] }}>
              <ResumePDFDescription
                items={descriptions}
                enableHighlight={enableHighlight}
                enableMistakeHighlight={enableMistakeHighlight}
              />
            </View>
          </View>
        ))}
      </View>
    </TemplateEighteenPDFSectionWithSubsections>
  );
};

export default Languages;
